import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InfiniteSlider } from '@/components/ui/infinite-slider';
import { ProgressiveBlur } from '@/components/ui/progressive-blur';
import { clientLogos } from '@/data/clientLogos';

export function ClientLogosSlider() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  
  const handleClick = () => navigate('/customer-stories');
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div 
      className="bg-background pb-2 md:pb-3 overflow-hidden cursor-pointer hover:bg-muted/20 transition-colors"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role="link"
      tabIndex={0}
      aria-label="View customer stories"
    >
      <div className="group relative m-auto max-w-6xl px-6 w-full">
        <div className="flex flex-col items-center md:flex-row">
          <div className="md:max-w-44 md:border-r md:pr-6">
            <p className="text-end text-sm">
              AI specialists behind <span className="hidden md:block"></span>
              <span className="md:hidden">inside your gimmefy workspace.</span>
              <span className="hidden md:inline">these smart teams </span>
            </p>
          </div>
          <div className="relative py-6 md:w-[calc(100%-11rem)] w-full overflow-hidden">
            <InfiniteSlider duration={40} gap={64}>
              {clientLogos.map((logo, index) => (
                <div key={`logo-${index}`} className="flex">
                  <img 
                    className="mx-auto h-8 w-fit opacity-80 hover:opacity-100 transition-all duration-300 filter grayscale hover:grayscale-0" 
                    src={logo} 
                    alt={`Client logo ${index + 1}`} 
                    height="32" 
                    width="100" 
                    loading="eager" 
                    onError={e => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }} 
                  />
                </div>
              ))}
            </InfiniteSlider>

            <div className="bg-gradient-to-r from-background absolute inset-y-0 left-0 w-20"></div>
            <div className="bg-gradient-to-l from-background absolute inset-y-0 right-0 w-20"></div>
            <ProgressiveBlur className="pointer-events-none absolute left-0 top-0 h-full w-20" direction="left" blurIntensity={1} />
            <ProgressiveBlur className="pointer-events-none absolute right-0 top-0 h-full w-20" direction="right" blurIntensity={1} />
            
            {/* Hover overlay button - desktop only */}
            {isHovered && (
              <div className="hidden lg:flex absolute inset-0 items-center justify-center bg-background/80 backdrop-blur-sm z-40">
                <span className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium shadow-lg">
                  Read their stories →
                </span>
              </div>
            )}
          </div>
          
          {/* Permanent button - mobile only */}
          <div className="flex lg:hidden justify-center mt-4">
            <span className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium shadow-lg">
              Read their stories →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
